import { CalendarRange } from "lucide-react";
import { useTaxYear } from "@/context/TaxYearContext";

/** Compact Assessment-Year / Financial-Year picker used across the tax module. */
export function TaxYearSelect({ className = "" }) {
  const { ay, setAy, ays } = useTaxYear();
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="tax-year-select-wrap">
      <CalendarRange className="w-4 h-4 text-gray-500 shrink-0" />
      <select
        value={ay}
        onChange={(e) => setAy(e.target.value)}
        data-testid="tax-year-select"
        className="h-8 border border-gray-300 rounded px-2 text-sm font-medium bg-white text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-600/30 focus:border-blue-600"
        title="Select Assessment Year"
      >
        {ays.map((a) => (
          <option key={a.ay} value={a.ay}>
            AY {a.ay} · FY {a.fy}{a.computable ? "" : " · view only"}
          </option>
        ))}
      </select>
    </div>
  );
}

export default TaxYearSelect;
